// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2zRiv","modalFooterButton":"ModalNotes_modalFooterButton__o1wWG"};